import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { ErrorIcon, Typography, WarningIcon } from '@routific/hive/v5';
import { VisitDtoModelType } from '../../../../store/mst/models';
import ResolveButton, { ResolveType } from '../../../shared/ResolveButton';
import { InlineRow } from './styles';

interface Props {
  visit: VisitDtoModelType;
  handleClickLink: () => void;
  canEditVisits: boolean;
}

const AddressErrorMessage: React.FC<Props> = ({ visit, handleClickLink, canEditVisits }) => {
  const { t } = useTranslation(['common', 'components']);

  const addressIsInvalid = visit.isInvalid;
  const resolveType = addressIsInvalid ? ResolveType.DANGER : ResolveType.WARNING;
  const tone = addressIsInvalid ? 'error' : 'warning';

  return (
    <InlineRow data-testid="address-error-message" style={{ flexWrap: 'wrap' }}>
      {addressIsInvalid
        ? <ErrorIcon size="sm" tone="error" />
        : <WarningIcon size="sm" tone="warning" />}
      <Typography
        variant="caption"
        tone={tone}
        data-cy="address-error-message"
      >
        {addressIsInvalid ? `${t('visitFields.address.noResultsFound')} ` : `${t('visitFields.address.questionable')} `}
      </Typography>
      <ResolveButton
        data-cy="address-error-message-link"
        type={resolveType}
        disabled={!canEditVisits}
        onResolve={handleClickLink}
        size="xsmall"
      />
    </InlineRow>
  );
};

export default observer(AddressErrorMessage);
